// Spec 078 US4 — rascunho da colocação no modo de edição. Store pequeno (Zustand), SEM three.js:
// a tela da linha o lê para a guarda de saída ("edições não salvas") sem baixar o chunk 3D.
// Não há "ferramenta selecionada": arrastar move, o anel gira — o modo é o gesto, não um botão.
import { create } from "zustand";
import type { MachinePlacement } from "@opus-dt/shared-types";

export interface SceneDraftState {
  /** colocações alteradas e ainda não salvas, por máquina */
  drafts: Record<string, MachinePlacement>;
  /** máquina selecionada no modo de edição */
  selectedId: string | null;
  set: (machineId: string, placement: MachinePlacement) => void;
  drop: (machineId: string) => void;
  select: (machineId: string | null) => void;
  reset: () => void;
}

export const useSceneDraft = create<SceneDraftState>((set) => ({
  drafts: {},
  selectedId: null,
  set: (machineId, placement) =>
    set((s) => ({ drafts: { ...s.drafts, [machineId]: normalize(placement) } })),
  drop: (machineId) =>
    set((s) => {
      const next = { ...s.drafts };
      delete next[machineId];
      return { drafts: next };
    }),
  select: (selectedId) => set({ selectedId }),
  reset: () => set({ drafts: {}, selectedId: null }),
}));

export const selectDirty = (s: SceneDraftState): boolean => Object.keys(s.drafts).length > 0;
/** Zustand 5 + useSyncExternalStore: seletor de HOOK devolve primitivo (um array novo por chamada
 *  vira loop infinito de render). `selectChangedIds` é para uso fora de hooks (getState). */
export const selectChangedCount = (s: SceneDraftState): number => Object.keys(s.drafts).length;
export const selectChangedIds = (s: SceneDraftState): string[] => Object.keys(s.drafts);

function normalize(p: MachinePlacement): MachinePlacement {
  const r = p.rotationDeg % 360;
  return {
    x: Math.round(p.x * 100) / 100,
    z: Math.round(p.z * 100) / 100,
    rotationDeg: Math.round((r < 0 ? r + 360 : r) * 10) / 10,
  };
}
